import React, { useEffect, useState } from 'react';
import { Header } from 'react-frontier';

interface LoadErrorProps{
	text: string
}

var LoadError = (props: LoadErrorProps)=>{
	useEffect(()=>{
		
	}, []);
	
	return <Header text={'Error'} subtext={props.text} iconName='face-frown-open' style={{ marginTop: 15, marginBottom: 15 }} />
}

export default LoadError;